import React, { forwardRef } from 'react';
import { optionalSubjectLabel } from '../utils/boardResultSubject';
import './BoardResultsPosterCard.css';

export const POSTER_SCHOOL_LOGO = `${process.env.PUBLIC_URL || ''}/fast-school-logo.png`;
export const POSTER_BG = `${process.env.PUBLIC_URL || ''}/poster-bg-9x16.png`;

function ordinalRank(rank) {
  const n = Number(rank);
  if (!Number.isFinite(n) || n < 1) return '';
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  switch (n % 10) {
    case 1: return `${n}st`;
    case 2: return `${n}nd`;
    case 3: return `${n}rd`;
    default: return `${n}th`;
  }
}

function splitName(fullName) {
  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { first: '', last: '' };
  if (parts.length === 1) return { first: parts[0].toUpperCase(), last: '' };
  const splitAt = parts.length === 4 ? 2 : parts.length - 1;
  return {
    first: parts.slice(0, splitAt).join(' ').toUpperCase(),
    last: parts.slice(splitAt).join(' ').toUpperCase()
  };
}

function formatPercentage(row) {
  if (row?.percentage_label) return String(row.percentage_label).replace(/\s/g, '');
  if (row?.percentage != null) return `${Number(row.percentage).toFixed(2)}%`;
  return '';
}

function initialsFromName(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const BoardResultsPosterCard = forwardRef(function BoardResultsPosterCard(
  { row, photoUrl },
  ref
) {
  const { first, last } = splitName(row?.student_name);
  const rankLabel = ordinalRank(row?.rank_no);
  const pct = formatPercentage(row);
  const marks = row?.total_marks != null ? String(row.total_marks) : '';
  const roll = row?.roll_no ? String(row.roll_no) : '';
  const subjectLabel = optionalSubjectLabel(row);
  const suffix = rankLabel.replace(/^\d+/, '');

  return (
    <div className="br-poster" ref={ref} data-poster-id={row?.id || roll}>
      <img src={POSTER_BG} alt="" className="br-poster-bg" crossOrigin="anonymous" />

      <img
        src={POSTER_SCHOOL_LOGO}
        alt="The Fast School"
        className="br-poster-logo"
        crossOrigin="anonymous"
      />

      <div className="br-poster-rank">
        <span className="br-poster-rank-num">{row?.rank_no ?? ''}</span>
        {suffix && <span className="br-poster-rank-suffix">{suffix}</span>}
      </div>

      {pct && <div className="br-poster-pct">{pct}</div>}

      <div className="br-poster-info">
        <div className="br-poster-name">
          {first && <div className="br-poster-first">{first}</div>}
          {last && <div className="br-poster-last">{last}</div>}
        </div>
        {roll && <div className="br-poster-roll">ROLL NO {roll}</div>}
        {marks && <div className="br-poster-marks">{marks}</div>}
        {subjectLabel && <div className="br-poster-subject">{subjectLabel}</div>}
      </div>

      <div className="br-poster-photo-wrap">
        {photoUrl ? (
          <img src={photoUrl} alt="" className="br-poster-photo" crossOrigin="anonymous" />
        ) : (
          <div className="br-poster-photo-placeholder">
            {initialsFromName(row?.student_name)}
          </div>
        )}
      </div>
    </div>
  );
});

export default BoardResultsPosterCard;
